import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "primereact/card";

import AuditSidebar from "../../audit-sidebar/AuditSidebar";
import API_ROUTES from "../../../api-routes";
import CustomeButton from "../../Button/index";
import PermissionGate from "~/components/PermissionGate";

import useEditAddress from "./useEditAddress";
import RegisteredAddress from "./components/RegisteredAddressTab.tsx";
import TradingAddress from "./components/TradingAddressTab.tsx";
import AddNewAddress from "./components/AddNewAddressTab.tsx";
import PhysicalAddressTab from "./components/PhysicalAddressTab.tsx";
import DeleteModal from "./DeleteModal";

import "./addresses.scss";
import { useSelector } from "react-redux";

const Addresses = () => {
  const { id } = useParams();
  const { role } = useSelector((state) => state.login);
  const {
    state,
    handleEditClick,
    handleRegisterDiscard,
    handleRegisterSave,
    RegisterAddressOnchange,
    handleChangeTab,
    handleTradeDiscard,
    tradeAdressOnchange,
    handleTradeSave,
    physicalAdressOnchange,
    handlePhysicalDiscard,
    handlePhysicalSave,
    handleNewToggle,
    handleNewAddress,
    handleNewDiscard,
    saveNewAddress,
    handleRemoveAdd,
    handleRemoveClose,
    removeAddress,
  } = useEditAddress();

  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  const auditLabels = () => ({
    update: "Information Updated",
    create: "Address Added",
    delete: "Address Deleted",
  });

  return (
    <>
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Addresses"
          endpoint={API_ROUTES.FETCH_ADDRESS_AUDIT}
          id={id}
          objectType="entity"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      <Card className="addresses-tab-view h-full">
        <div className="flex justify-content-between formgrid grid ">
          {state.entityConfigEnable && (
            <div className="grid">
              <h4 className="address-heading">Addresses</h4>
            </div>
          )}
          {state.entityConfigEnable && !state.isLoading ? (
            <div className="flex gap-2 flex-wrap justify-end">
              <PermissionGate
                resource="entity"
                action="modify"
                resourceAttr={{ entity_id: id }}
              >
                <CustomeButton
                  label="View History"
                  variant="outlined"
                  className="mr-2"
                  icon="pi pi-history"
                  iconPos="right"
                  onClick={() => setAuditSidebarVisible(true)}
                />
              </PermissionGate>
            </div>
          ) : (
            <div className="grid w-full"></div>
          )}

          {!state.entityConfigEnable ? (
            <div className="grid w-full">
              <RegisteredAddress
                state={state}
                entityPlusEnable={state?.entityConfigEnable || false}
                handleEditClick={handleEditClick}
                handleRegisterDiscard={handleRegisterDiscard}
                handleRegisterSave={handleRegisterSave}
                RegisterAddressOnchange={RegisterAddressOnchange}
                setAuditSidebarVisible={setAuditSidebarVisible}
                entityId={id}
              />
            </div>
          ) : (
            <TabView
              className="w-full"
              activeIndex={state.activeTab}
              onTabChange={(e) => handleChangeTab(e.index)}
            >
              <TabPanel header="Registered">
                <RegisteredAddress
                  state={state}
                  entityPlusEnable={state?.entityConfigEnable}
                  handleEditClick={handleEditClick}
                  handleRegisterDiscard={handleRegisterDiscard}
                  handleRegisterSave={handleRegisterSave}
                  RegisterAddressOnchange={RegisterAddressOnchange}
                  entityId={id}
                />
              </TabPanel>

              {state.isTradeAvailable && (
                <TabPanel header="Trading">
                  <TradingAddress
                    state={state}
                    handleEditClick={handleEditClick}
                    handleTradeDiscard={handleTradeDiscard}
                    tradeAdressOnchange={tradeAdressOnchange}
                    handleTradeSave={handleTradeSave}
                    removeAddress={handleRemoveAdd}
                    entityId={id}
                  />
                </TabPanel>
              )}

              {state.isPhysicalAvailable && (
                <TabPanel header="Physical">
                  <PhysicalAddressTab
                    state={state}
                    handleEditClick={handleEditClick}
                    handlePhysicalDiscard={handlePhysicalDiscard}
                    physicalAdressOnchange={physicalAdressOnchange}
                    handlePhysicalSave={handlePhysicalSave}
                    removeAddress={handleRemoveAdd}
                    entityId={id}
                  />
                </TabPanel>
              )}

              {["GXM_ADMIN"].includes(role) &&
                (!state.isTradeAvailable || !state.isPhysicalAvailable) && (
                  <TabPanel
                    header={
                      <span className="flex align-items-center gap-2">
                        Add New Address <i className="pi pi-plus" />
                      </span>
                    }
                  >
                    <AddNewAddress
                      handleNewAddress={handleNewAddress}
                      states={state}
                      handleNewToggle={handleNewToggle}
                      data={state?.newAddress}
                      saveNewAddress={saveNewAddress}
                      handleNewDiscard={handleNewDiscard}
                      entityId={id}
                    />
                  </TabPanel>
                )}
            </TabView>
          )}

          {state?.deletemodal && (
            <DeleteModal
              visible={state?.deletemodal}
              selectedAddress={state?.addressSelect}
              closeModal={() => handleRemoveClose()}
              deleteAddress={() => removeAddress()}
              isLoading={state?.isRemoving}
            />
          )}
        </div>
      </Card>
    </>
  );
};

export default Addresses;
